import { createSlice } from "@reduxjs/toolkit";
import { Setting } from "../models/Setting";

const SettingsInitialState: {
	settings: Setting[];
	settingSelected: Setting | null;
} = {
	settings: [],
	settingSelected: null,
};

export const SettingsReducer = createSlice({
	name: "__",
	initialState: SettingsInitialState,
	reducers: {
		setSettings(state, { payload }) {
			state.settings = payload;
		},
		setSettingSelected(state, { payload }) {
			state.settingSelected = payload;
		},
	},
});
